// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo__logo--blue--11JCC"};
    if(module.hot) {
      // 1605595225196
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  